import {Component} from 'lowkey-component'

import {ProgressAnimationItems} from '@components/helpers/ProgressAnimationItems'
import {ProgressElement} from '@components/helpers/ProgressElement'
import {MediaQuery} from '@services/MediaQuery'

export class ProgressAnimation extends Component<HTMLDivElement> {
  mq = MediaQuery.create()
  stickyElement: HTMLDivElement | undefined = undefined
  items = new ProgressAnimationItems()
  progress = new ProgressElement()

  constructor(element: HTMLDivElement) {
    super(element)
    this.onProgress = this.onProgress.bind(this)
  }

  onProgress(percent: number) {
    this.items.seek(percent)
  }

  didMount() {
    if (this.mq.isPhone()) {
      return
    }

    this.items.init(this.element)

    this.stickyElement = this.element?.querySelector('.js-progress-animation-sticky') as HTMLDivElement

    this.progress.init(this.element, this.stickyElement)

    this.progress.onProgress.connect(this.onProgress)


  }

  didUnmount() {
    this.progress.destroy()
  }

}
